// src/api/auth.ts
import { Amplify } from 'aws-amplify';
import { getAuthConfig } from '../config/auth';

export const configureAuth = async () => {
  const authConfig = await getAuthConfig();
  
  // Make sure we have all required configuration
  if (!authConfig.userPoolId || !authConfig.userPoolClientId) {
    throw new Error('Missing required Cognito configuration');
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: authConfig.userPoolId,
        userPoolClientId: authConfig.userPoolClientId,
        signUpVerificationMethod: 'code',
        loginWith: {
          oauth: {
            domain: authConfig.loginWith.oauth.domain,
            scopes: authConfig.loginWith.oauth.scopes,
            redirectSignIn: authConfig.loginWith.oauth.redirectSignIn,
            redirectSignOut: authConfig.loginWith.oauth.redirectSignOut,
            responseType: authConfig.loginWith.oauth.responseType
          }
        }
      }
    }
  });
};
